import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import ObjectiveBoxMobile from "./ObjectiveBoxMobile";
import Objective from "./Objective";

const Div = styled.div`
                    width:100%;
                    padding: 10px 0;

                    h2{
                        font-size:18px;
                        color:#000;
                        text-align:center;
                        padding-top:8px;
                        font-weight:bold;
                        margin-bottom:5px;
                    }
                    h3{
                        font-size:16px;
                        color:#000;
                        text-align:center;
                        font-weight:normal;
                    }
                    .col-fifth{
                        position: relative;
                        float:left;
                        width: 100%;
                        padding-right: 15px;
                        padding-left: 15px;
                        flex: 0 0 20%;
                        max-width: 20%;
                        @media (max-width: 1300px) {
                            flex: 0 0 25%;
                            max-width: 25%;
                        }
                    }

`;

function renderObjectives(objectives) {

    if (objectives) {
        return objectives.map((item, index) => {
            return <div className="col-fifth px-1 py-1" key={index}>
                <Objective item={item} />
            </div>

        })
    }
}
function renderObjectivesMobile(objectives) {

    if (objectives) {
        return objectives.map((item, index) => {
            return <div className="col-sm-12" key={index}>

                <ObjectiveBoxMobile item={item} />

            </div>
        })
    }
}

function Objectives(props) {
    const [objectives, setObjectives] = useState(props.objectives.sort((a, b) => new Date((a.finish ? a.finish : '3000-12-12')) - new Date((b.finish ? b.finish : '3000-12-12'))));


    useEffect(() => {
        if (props.objectives) {
            setObjectives(props.objectives.sort((a, b) => new Date((a.finish ? a.finish : '3000-12-12')) - new Date((b.finish ? b.finish : '3000-12-12'))));
        }
    });

    return (
        <Div>
            <div className="row">
                <div className="col-12">
                    <h2>Business Priorities</h2>
                    <h3>Our key milestones</h3>
                </div>
            </div>
            <div className="row">
                <div className="col-12 px-5">
                    <div className="row show-desktop">
                        {renderObjectives(objectives)}
                    </div>
                    <div className="row show-mobile">
                        {renderObjectivesMobile(objectives)}
                    </div>
                </div>
            </div>
        </Div>
    );
}

export default Objectives;